import { Schema } from 'rsuite';
import { Edit, isMarginFilled } from './pricingMarginsState';

const { NumberType } = Schema.Types;

const NUMBER_MESSAGE = 'Must be a number.';
const DEMANDED_MINIMUM_MESSAGE = 'One of partner absolute or relative demanded minimum margin is required.';
const REGULAR_MESSAGE = 'One of partner absolute or relative regular margin is required.';

function validateDemandedMinimumFilled(_ignored: string | number, edit: Edit): boolean {
  return isMarginFilled(edit.partnerDemandedMinimumMarginAbs)
    || isMarginFilled(edit.partnerRelativeDemandedMinimumMargin);
}

function validateRegularFilled(_ignored: string | number, edit: Edit): boolean {
  return isMarginFilled(edit.partnerRegularMarginAbs)
    || isMarginFilled(edit.partnerRelativeRegularMargin);
}

const validationModel = Schema.Model({
  partnerDemandedMinimumMarginAbs: NumberType(NUMBER_MESSAGE)
    .addRule(validateDemandedMinimumFilled, DEMANDED_MINIMUM_MESSAGE, true),

  partnerRelativeDemandedMinimumMargin: NumberType(NUMBER_MESSAGE)
    .proxy(['partnerDemandedMinimumMarginAbs']),

  partnerRegularMarginAbs: NumberType(NUMBER_MESSAGE)
    .addRule(validateRegularFilled, REGULAR_MESSAGE, true),

  partnerRelativeRegularMargin: NumberType(NUMBER_MESSAGE)
    .proxy(['partnerRegularMarginAbs']),
});

export default validationModel;
